import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, Interval, RestClientContinuable } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { environment } from '../../../../../environments/environment'
import { ControlTerminalMode } from '../../control-terminal-mode'
import { TerminalOrder } from './terminal-order'

export class TerminalOrderFilter {
  public static readonly DISPLAY_MODE = 'displayMode'

  public static live(
    workCenterId: string,
    workStationId: string,
    currentTime: Instant,
    includeUnstartable: boolean
  ): Filter[] {
    return [
      new Filter('workCenterId', workCenterId),
      new Filter('workStationId', workStationId),
      new Filter(TerminalOrderFilter.DISPLAY_MODE, ControlTerminalMode.LIVE),
      new Filter('timestamp', currentTime.toString()),
      new Filter('scheduleInterval', null),
      new Filter('includeUnstartable', String(includeUnstartable)),
    ]
  }

  public static preview(
    workCenterId: string,
    workStationId: string,
    scheduleInterval: Interval,
    includeUnstartable: boolean
  ): Filter[] {
    return [
      new Filter('workCenterId', workCenterId),
      new Filter('workStationId', workStationId),
      new Filter(TerminalOrderFilter.DISPLAY_MODE, ControlTerminalMode.PREVIEW),
      new Filter('scheduleInterval', scheduleInterval.toInstantString()),
      new Filter('timestamp', null),
      new Filter('includeUnstartable', String(includeUnstartable)),
    ]
  }
}

@Injectable({
  providedIn: 'root',
})
export class TerminalOrderService extends RestClientContinuable<TerminalOrder, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/terminal-orders', http, {
      idField: 'id',
    })
  }
}
